var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabbarAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6414_3040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.39258 18.4082H14.668C16.2891 18.4082 17.0605 17.9199 17.0605 16.8457C17.0605 14.2871 13.8281 10.5859 8.53516 10.5859C3.23242 10.5859 0 14.2871 0 16.8457C0 17.9199 0.771484 18.4082 2.39258 18.4082ZM1.93359 16.9336C1.67969 16.9336 1.57227 16.8652 1.57227 16.6602C1.57227 15.0586 4.05273 12.0605 8.53516 12.0605C13.0078 12.0605 15.4883 15.0586 15.4883 16.6602C15.4883 16.8652 15.3906 16.9336 15.1367 16.9336H1.93359ZM8.53516 9.375C10.8594 9.375 12.7539 7.30469 12.7539 4.78516C12.7539 2.28516 10.8691 0.322266 8.53516 0.322266C6.2207 0.322266 4.31641 2.32422 4.31641 4.80469C4.32617 7.31445 6.21094 9.375 8.53516 9.375ZM8.53516 7.90039C7.10938 7.90039 5.88867 6.5332 5.88867 4.80469C5.88867 3.10547 7.08984 1.79688 8.53516 1.79688C9.99023 1.79688 11.1816 3.08594 11.1816 4.78516C11.1816 6.51367 9.9707 7.90039 8.53516 7.90039Z",
    fill: "#1D1E2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6414_3040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0605,
    height: 18.4082,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabbarAccount);
export default __webpack_public_path__ + "static/media/tabbar-account.8134e6efdf0c7224ed27078524068ebf.svg";
export { ForwardRef as ReactComponent };